var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { createRoot } from 'react-dom/client';
import { init as sentryInit } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { init as initFms, getInitialLanguage, } from '@storebrand-digital/fms-translations';
import auth from './utils/auth';
import App from './app';
import prependAssets from './utils/prependAssets';
import artifactInfo from '../artifactInfo.json';
import { createAxiosInterceptor, createFscAxiosInterceptor, } from './utils/axios';
import initDatadog from './utils/datadog';
import no from './fms-fallbacks/fallback-no.json';
import en from './fms-fallbacks/fallback-en.json';
function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        var root;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, auth.init()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, auth.login()];
                case 2:
                    _a.sent();
                    prependAssets();
                    return [4 /*yield*/, createAxiosInterceptor()];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, createFscAxiosInterceptor()];
                case 4:
                    _a.sent();
                    sentryInit({
                        dsn: window.env.SENTRY_DSN,
                        release: artifactInfo.sentryRelease,
                        environment: window.env.SENTRY_ENVIRONMENT,
                        integrations: [new Integrations.BrowserTracing()],
                        tracesSampleRate: window.env.SENTRY_ENVIRONMENT === 'production' ? 0.25 : 1.0,
                    });
                    initDatadog();
                    if (!window.location.href.includes('displaymode=app')) {
                        import('navbar/init').then(function (navbar) { return navbar.default(); });
                        import('footer/init').then(function (footer) { return footer.default(); });
                    }
                    return [4 /*yield*/, initFms({
                            clientId: 'secure-messages-web',
                            documentIds: ['secureMessaging'],
                            fallback: { no: no, en: en },
                            language: getInitialLanguage(),
                            version: window.env.TRANSLATION_VERSION,
                        })];
                case 5:
                    _a.sent();
                    root = createRoot(document.getElementById('project-root'));
                    root.render(React.createElement(App, null));
                    return [2 /*return*/];
            }
        });
    });
}
export default bootstrap;
